<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal task">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="header">
          <div class="row">
            <div class="col-6">
              <div class="filename-wrapper">
                <input
                  type="text"
                  v-model="task.props.filename"
                  class="props-input"
                  ref="report-name"
                  @focus="reportNameIsFocused = true"
                  :class="{ 'is-duplicate': isNameDuplicate, error: shakeName }"
                  :disabled="!isUserHasAccess"
                />
              </div>
            </div>
            <div class="col" v-show="isAdmin">
              <label class="caption">Text als reines HTML speichern</label>
              <input
                type="checkbox"
                style="width: 25px"
                :checked="task.props.pureHTML"
                :disabled="!isUserHasAccess"
                @click="setPureHTML"
              />
            </div>
            <div class="col">
              <div class="tools">
                <div
                  class="round-button item"
                  @click="exportPDF()"
                  v-b-tooltip.hover.top
                  title="PDF Herunterladen"
                >
                  <i class="fas fa-file-pdf"></i>
                </div>
                <div
                  class="round-button item"
                  @click="exportHTML()"
                  v-b-tooltip.hover.top
                  title="HTML Herunterladen"
                >
                  <i class="fas fa-file-invoice"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab">
          <div class="params"></div>
          <div class="content-area container" v-if="!developerMode">
            <div class="msg" v-if="maxCharExceeded">
              <p v-if="!showMsgTextTooLong">
                Nachricht zu lange. {{ this.charCounter }} / 200'000 Zeichen.
              </p>
              <p v-else>
                Bitte lösche {{ charCounter - 200000 }} Zeichen um zu speichern.
              </p>
            </div>
            <vue-editor
              ref="contant-editor"
              id="editor"
              class="vue-editor"
              v-model="richContent"
              :editorToolbar="customToolbar"
              @focus="onEditorFocus"
              @blur="onEditorBlur"
              :editorOptions="editorSettings"
              :class="{ attention: maxCharExceeded }"
            ></vue-editor>
          </div>
          <div
            class="content-area container p-0"
            style="overflow: scroll"
            @click="reportNameIsFocused = false"
          >
            <m-editor
              v-if="isUserHasAccess"
              ref="m-editor"
              v-model="markdownText"
              :class="{ 'disabled-tools': !isUserHasAccess }"
              theme="dark"
              :mode="mEditorMode"
              @on-change="updateHTML"
            />
            <div
              v-if="task.props.pureHTML || !isUserHasAccess"
              style="padding-top: 25px"
              v-html="markdownText"
              @blur="saveChanges"
              contenteditable
            ></div>
          </div>
          <div class="tools">
            <div class="element" v-if="this.dataFields.length > 0">
              <div class="button" @click.stop="toggleDataFields">
                <svg
                  width="24px"
                  height="24px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 450 600"
                  class="data-fields"
                >
                  <g>
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      id="svg_20"
                      x="321.42857360839844"
                      y="328.7261941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="322.1230182647705"
                      y="327.4761941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_29"
                      transform="rotate(89.70001220703125 435.1231689453125,342.4761657714844) "
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="-0.17856436967849731"
                      y="233.25000143051147"
                      width="351.9325393145858"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_28"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="0.75"
                      width="403.32143771648407"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_32"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="117.03968334197998"
                      width="404.2142987717938"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_30"
                    />
                  </g>
                </svg>
              </div>
              <div class="info-wrapper" v-show="!tools.addDataField.show">
                <div class="info">Daten einfügen</div>
              </div>
              <div
                class="toggle-list-wrapper data-fields"
                v-if="tools.addDataField.show"
                v-click-outside="hideDataFields"
              >
                <div class="search">
                  <span class="search-icon"></span>
                  <input name="search" v-model="dataFieldFilter" />
                </div>
                <div
                  v-for="(f, index) in filteredDataFields"
                  :key="index"
                  class="item"
                  @click="insertInputData(f.name)"
                >
                  <div class="label">{{ f.name }}</div>
                </div>
              </div>
            </div>
            <!-- Button to toggle developer mode -->
            <!--<div class="element">
              <div class="button" @click="toggleDeveloperMod">
                <svg
                  width="24px"
                  height="24px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 450 600"
                  class="data-fields"
                >
                  <g>
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      id="svg_20"
                      x="321.42857360839844"
                      y="328.7261941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="322.1230182647705"
                      y="327.4761941432953"
                      width="226"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_29"
                      transform="rotate(89.70001220703125 435.1231689453125,342.4761657714844) "
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="-0.17856436967849731"
                      y="233.25000143051147"
                      width="351.9325393145858"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_28"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="0.75"
                      width="403.32143771648407"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_32"
                    />
                    <rect
                      fill
                      stroke-dashoffset
                      fill-rule="nonzero"
                      x="0"
                      y="117.03968334197998"
                      width="404.2142987717938"
                      height="30"
                      style="color: rgb(0, 0, 0)"
                      class
                      id="svg_30"
                    />
                  </g>
                </svg>
              </div>
              <div class="info-wrapper">
                <div class="info">Developer modus</div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <LoadingSpinner v-show="loading" :loadingCaption="loadingMessage" />
    </div>
  </div>
</template>

<script>
import button from '!raw-loader!../../assets/files/html-button-for-email.txt';
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import { Quill } from 'vue2-editor';
import LoadingSpinner from '../../components/widgets/LoadingSpinner.vue';

// Markdown
import MarkdownShortcuts from 'quill-markdown-shortcuts';
Quill.register('modules/markdownShortcuts', MarkdownShortcuts);

//custom font size in toolbar
var SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['8px', '12px', '16px', '24px', '36px'];
Quill.register(SizeStyle, true);

//custom font family in toolbar
var Font = Quill.import('attributors/style/font');
Font.whitelist = ['inconsolata', 'roboto', 'mirza', 'arial'];
Quill.register(Font, true);

//MD editor
import mEditor from 'simple-m-editor';
import 'simple-m-editor/dist/simple-m-editor.css';
const mdEditorConfig = [
  {
    icon: 'icon-zitibiaoti',
    title: 'Überschrift',
    showIcon: true,
    loadingMessage: null,
    children: [
      { text: 'H1', size: 32, title: 'H1', content: '# h1' },
      { text: 'H2', size: 24, title: 'H1', content: '## h2' },
      { text: 'H3', size: 18, title: 'H1', content: '### h3' },
      { text: 'H4', size: 16, title: 'H1', content: '#### h4' },
    ],
  },
  {
    icon: 'icon-zitijiacu',
    title: 'Fett',
    content: '**Fett** ',
    showIcon: true,
  },
  {
    icon: 'icon-zitixieti',
    title: 'Kursiv',
    content: '*Kursiv* ',
    showIcon: true,
  },
  {
    icon: 'icon-zitishanchuxian',
    title: 'Durchgestrichen',
    content: '~~Durchgestrichen~~ ',
    showIcon: true,
  },
  {
    icon: 'icon-zitixiahuaxian',
    title: 'Unterstrichen',
    content: '<u>Unterstrichen</u>',
    showIcon: true,
  },
  {
    icon: 'icon-charulianjie',
    title: 'Link',
    content: '[Link](https://codelos.io)',
    showIcon: true,
  },
  {
    icon: 'icon-yinyong',
    title: 'Zitat',
    content: '\n> Zitat',
    showIcon: true,
  },
  {
    icon: 'icon-zitidaima',
    title: 'Code',
    content: "\n```\n console.log('hello world');\n```\n",
    showIcon: true,
  },
  {
    icon: 'icon-charutupian',
    title: 'Bild',
    content:
      '\n![Bild](https://res.cloudinary.com/gharnati-com/image/upload/v1645138347/logo_iy0wru.svg)\n',
    showIcon: true,
  },
  {
    icon: 'icon-youxupailie',
    title: 'Aufzählung',
    content: '\n1. Element1\n2. Element2\n3. Element3\n',
    showIcon: true,
  },
  {
    icon: 'icon-wuxupailie',
    title: 'Liste',
    content: '\n- Element1\n- Element2\n- Element3\n',
    showIcon: true,
  },
  {
    icon: 'icon-fengexian',
    title: 'Linie',
    content: '\n***\n',
    showIcon: true,
  },
  {
    icon: 'icon-biaodanzujian-biaoge',
    title: 'Tabelle',
    content:
      '\nBezeichnung1| Bezeichnung2 \n--- |---\nElement1 | Element2\nElement3 | Element4',
    showIcon: true,
  },
  {
    icon: 'icon-zuoduiqi',
    title: 'Linksbündig',
    content: '\n<p align="left">Linksbündig</p>\n',
    showIcon: true,
  },
  {
    icon: 'icon-juzhongduiqi',
    title: 'Zentriert',
    content: '\n<center>Zentriert</center>\n',
    showIcon: true,
  },
  {
    icon: 'icon-youduiqi',
    title: 'Rechtsbündig',
    content: '\n<p align="right">Rechtsbündig</p>\n',
    showIcon: true,
  },
];

export default {
  name: 'html-editor',
  data() {
    return {
      loadingMessage: null,
      markdownText: '',
      markdownContent: '',
      dataFieldFilter: null,
      actionFilter: null,
      showMsgTextTooLong: false,
      mEditorMode: 'live',
      developerMode: true,
      shakeName: false,
      actions: [
        {
          name: 'Gutschrift beantragen',
          html: button,
        },
        {
          name: 'Gutschrift Bestätigen/Ablehnen',
          html: button,
        },
      ],
      tools: {
        attache: {
          show: false,
        },
        addDataField: {
          show: false,
        },
        addAction: {
          show: false,
        },
      },
      loading: false,
      richContent: '<br>',
      customToolbar: [
        [{ font: ['inconsolata', 'roboto', 'mirza', 'arial'] }],
        [{ size: ['8px', '12px', '16px', '24px', '36px'] }],
        ['bold', 'italic', 'underline', 'link'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
          { color: [] },
          { background: [] },
        ],
      ],
      editorSettings: {
        modules: {
          clipboard: {
            matchers: [],
          },
        },
        theme: 'snow',
        placeholder: this.placeholder,
      },
      reportNameIsFocused: false,
    };
  },
  props: {
    task: Object,
    input: Array,
    isUserHasAccess: { type: Boolean, default: true },
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  methods: {
    saveChanges(e) {
      this.markdownText = e.target.innerHTML;
    },
    toggleDeveloperMod() {
      if (this.developerMode) {
        this.richContent = this.markdownContent;
        this.developerMode = false;
      } else {
        this.markdownText = this.richContent;
        this.developerMode = true;
        this.$nextTick(() => {
          // The whole view is rendered, so I can safely access or query
          this.configMarkdownEditor();
        });
      }
    },

    configMarkdownEditor() {
      this.$refs['m-editor'].config = mdEditorConfig;
      if (!this.isUserHasAccess) {
        this.$refs['m-editor'].addContent = () => {};
        this.$refs['m-editor'].handleModeEdit = () => {};
      }

      this.$refs['m-editor'];
    },

    onEditorBlur() {
      this.hideToolBar();
    },

    onEditorFocus() {
      this.showToolBar();
    },

    showToolBar() {
      var bar = this.$el.querySelector('.ql-toolbar');
      bar.classList.add('visible');
      bar.classList.remove('hidden');
    },

    hideToolBar() {
      var bar = this.$el.querySelector('.ql-toolbar');
      bar.classList.add('hidden');
      bar.classList.remove('visible');
    },

    fetchData: function () {
      this.task.props.attachment = [];
      if (this.task.props.hasOwnProperty('message')) {
        this.markdownText = this.task.props.markdown;
      }
    },

    close: function () {
      if (!this.isNameDuplicate) {
        let txt = this.richContent;
        // Use undefined when area is empty
        if (txt == undefined) this.$emit('close');
        else if (txt.length > 200000) {
          this.showMsgTextTooLong = true;
          setTimeout(() => {
            this.showMsgTextTooLong = false;
          }, 1000);
        } else {
          // TODO: FIND BETTER SOLUTION
          if (this.task.props.pureHTML) {
            this.task.props.message = this.markdownText;
          } else this.task.props.message = txt;

          this.task.props.markdown = this.markdownText;
          this.loadingMessage = 'Wird gespeichert...';
          this.loading = true;
          this.saveAsOutput().then(() => {
            this.loading = false;
            this.$emit('close');
          });
        }
      } else {
        this.shakeName = true;
        setTimeout(() => {
          this.shakeName = false;
        }, 500);
      }
    },

    getMessage: function () {
      if (this.task.props.message) return this.task.props.message;
      else return '<br>';
    },

    getImgUrl: function (img) {
      var images = require.context('../../assets/img/', false, /\.png$/);
      return images(img);
    },

    showAttacheFile: function () {
      this.tools.attache.show = true;
    },

    hideAttacheFile: function () {
      this.tools.attache.show = false;
    },
    toggleAttacheFile: function () {
      this.tools.attache.show = !this.tools.attache.show;
      this.hideDataFields();
      this.hideActions();
    },
    hideDataFields: function () {
      this.tools.addDataField.show = false;
    },
    toggleDataFields: function () {
      this.tools.addDataField.show = !this.tools.addDataField.show;
      this.hideAttacheFile();
      this.hideActions();
    },
    hideActions: function () {
      this.tools.addAction.show = false;
    },
    toggleActions: function () {
      this.tools.addAction.show = !this.tools.addAction.show;
      this.hideDataFields();
      this.hideAttacheFile();
    },
    insertInputData: function (content) {
      if (!this.reportNameIsFocused) this.insertMarkdownText(content);
      else {
        let value = this.task.props.filename;
        let cursorPos = this.$refs['report-name'].selectionStart;

        this.task.props.filename =
          value.slice(0, cursorPos) +
          '{' +
          content +
          '}' +
          value.slice(cursorPos);
      }
    },
    insertMarkdownText: function (content) {
      // Get Markdown textarea and cursor position
      let mdEditorTxtArea =
        this.$refs[
          'm-editor'
        ].$el.children[1].children[0].children[0].children[1].getElementsByTagName(
          'textarea'
        )[0];
      let cursorPos = mdEditorTxtArea.selectionStart;

      // Check if start is new line or has space & insert content at cursor position
      let start = this.markdownText.slice(cursorPos - 1, cursorPos);
      if (/ |\n/.test(start)) {
        this.markdownText =
          this.markdownText.slice(0, cursorPos) +
          '{' +
          content +
          '}' +
          this.markdownText.slice(cursorPos);
      } else {
        this.markdownText =
          this.markdownText.slice(0, cursorPos) +
          ' {' +
          content +
          '}' +
          this.markdownText.slice(cursorPos);
      }
    },
    insertText: function (content) {
      let q = this.$refs['contant-editor'].quill;
      var selection = q.getSelection(true);
      var insertText = '{' + content + '}';
      q.insertText(selection.index, insertText);
    },
    insertHTMLasText: function (content) {
      let q = this.$refs['contant-editor'].quill;
      var selection = q.getSelection(true);
      q.insertText(selection.index, content);
    },
    insertHTML: function (content) {
      let oldContent = this.richContent;
      this.richContent = oldContent + content;
    },
    isAttached: function (file) {
      return (
        this.task.props.attachment.filter((f) => f.name == file.name).length > 0
      );
    },
    addAttachment: function (file) {
      this.task.props.attachment.push({ label: file.name });
    },
    removeAttachment: function (file) {
      this.task.props.attachment = this.task.props.attachment.filter(
        (f) => f.label != file.name
      );
    },
    attacheFile: function (file) {
      if (file.selected) this.removeAttachment(file);
      if (!file.selected) this.addAttachment(file);
      this.showAttacheFile();
    },
    getTemplateFromUrl() {
      let self = this;
      fetch(this.task.props.templateUrl)
        .then(function (response) {
          // The API call was successful!
          return response.text();
        })
        .then(function (html) {
          //self.$refs["rich-text"].richContent = html;
          self.insertHTMLasText(html);
          self.task.props.message = html;
        })
        .catch(() => {});
    },
    saveAsOutput: async function () {
      let output = await this.getReport();

      this.task.output = [output];

      // Accumulate input
      this.$set(this.task, 'output', this.task.output.concat(this.task.input));
    },
    exportPDF: async function () {
      this.loadingMessage = 'PDF-Dokument wird erstellt...';
      this.loading = true;
      let report = await this.getReport();

      let name = this.replacePlaceholder(report.label);
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(report.value);
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
    },
    exportHTML: function () {
      this.loadingMessage = 'HTML-Dokument wird erstellt...';
      this.loading = true;
      let name = this.replacePlaceholder(this.task.props.filename);
      let dataStr =
        'data:text/html;charset=utf-8,' + encodeURIComponent(this.richContent);
      let link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute('download', name + '.html');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
    },
    replacePlaceholder: function (name) {
      // Replace placeholder in name
      if (name.includes('{')) {
        let placeholder = name.split('{')[1].split('}')[0];
        let match = this.task.input.filter((e) => e.name == placeholder)[0]
          .value;
        name = name.replace('{' + placeholder + '}', match);
      }
      return name;
    },
    getReport: async function () {
      // Call API
      var url = process.env.VUE_APP_FLOW_RUNNER_API;
      url += '/report';

      var filename = this.task.props.filename;

      // Header
      let myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      // TODO FIND BETER SOLUTION
      let content;
      if (
        (this.task.props.hasOwnProperty('pureHTML') &&
          this.task.props.pureHTML == true) ||
        !this.isUserHasAccess
      ) {
        content = this.markdownText;
      } else content = this.richContent;

      let payload = {
        content: content,
        values: this.task.input,
        filename: filename,
      };

      return await fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'post',
      })
        .then((response) => {
          if (response.status != 200) throw new Error(response.statusText);
          else return response.blob();
        })
        .then((blob) => {
          // Put results in output
          let newBlob = new Blob([blob], { type: 'application/pdf' });
          // TODO: check if files is needed
          let el = {
            label: filename + '.pdf',
            name: filename + '.pdf',
            type: 'file',
            value: newBlob,
          };
          return el;
        })
        .catch((e) => {
          let el = {
            label: 'error',
            type: 'text',
            value: e,
          };
          this.isLoading = false;
          return el;
        });
    },
    updateCode: function () {
      this.task.props.message = this.richContent;
    },
    showMarkdownEditor: function () {
      this.markdownContent = this.richContent;
    },
    updateHTML(data) {
      this.richContent = data.htmlContent;
    },
    setPureHTML: function () {
      if (this.task.props.hasOwnProperty('pureHTML'))
        this.$set(this.task.props, 'pureHTML', !this.task.props.pureHTML);
      else this.$set(this.task.props, 'pureHTML', true);
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    charCounter() {
      try {
        return this.richContent.length;
      } catch {
        return 0;
      }
    },
    maxCharExceeded() {
      return this.charCounter > 200000;
    },

    dataFields() {
      let dataFields = [];

      this.task.input.forEach((e) => {
        if (e.type != 'file' && !e.hasOwnProperty('isFromSettings'))
          dataFields.push({
            name: e.name,
            value: e.value,
          });
      });
      return dataFields;
    },
    filteredDataFields() {
      return this.dataFields.filter((f) => {
        if (this.dataFieldFilter)
          return (
            f.name.toLowerCase().indexOf(this.dataFieldFilter.toLowerCase()) >
            -1
          );
        else return this.dataFields;
      });
    },
    filteredActions() {
      return this.actions.filter((a) => {
        if (this.actionFilter)
          return (
            a.name.toLowerCase().indexOf(this.actionFilter.toLowerCase()) > -1
          );
        else return this.actions;
      });
    },
    isNameDuplicate() {
      const htmlFilenames = this.getFileNamesFromProps(
        'HTML',
        'filename',
        this.task.id
      );

      return htmlFilenames.includes(this.task.props.filename);
    },
    encodedHTML() {
      var txt = document.createElement('textarea');
      txt.innerHTML = this.richContent;
      return txt.value;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  created() {
    if (this.task.props.markdown != '' || !this.isUserHasAccess)
      this.mEditorMode = 'preview';

    setTimeout(() => {
      if (
        this.task.props.templateUrl != '' &&
        // The last comparisation is the default value after deleting all HTML
        // TODO: remove this curious HTML value to show placeholder
        (this.task.props.message == '' ||
          this.task.props.message == '<p><br></p><p>\n\n  \n</p>')
      )
        this.getTemplateFromUrl();
    }, 200);
  },
  mounted: function () {
    this.fetchData();
    this.configMarkdownEditor();
  },
  components: {
    VueEditor,
    mEditor,
    LoadingSpinner,
  },
};
</script>

<style scoped>
/*
@import "https://cdn.jsdelivr.net/npm/pretty-checkbox@3.0/dist/pretty-checkbox.min.css";
*/

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';

@import 'https://fonts.googleapis.com/css?family=Roboto';
@import 'https://fonts.googleapis.com/css?family=Inconsolata';
@import 'https://fonts.googleapis.com/css?family=Mirza';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

.tab {
  text-align: left;
  padding: 20px 31px;
  height: 96%;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 80%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: 10%;
  top: 1%;
  height: 98%;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
  height: 10px;
}

button.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  left: 3px;
  position: relative;
  top: -153px;
  left: -18px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.pull-right.default {
  margin-top: 0;
}

.e-mail-params {
  height: 176px;
}

.form-group {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dee0e4;
}

.form-group .label {
  margin-top: 20px;
  text-transform: none;
}

.form-group input {
  width: 100%;
  border: 0;
  padding-bottom: 14px;
  padding-top: 18px;
}

input:focus {
  outline: none;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

.pretty {
  line-height: 36px;
}

.logo {
  width: 35px;
  margin-top: 24px;
}

.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: relative;
  top: -127px;
  border-width: 1px;
  border-color: var(--color-black);
  left: 1px;
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 6px;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}

.search {
  width: 200px;
  padding: 11px 0 11px 0;
  height: 21px;
  margin-left: 12px;
  border-bottom: solid 1px #bdc3c7;
  margin-right: 12px;
  margin-bottom: 12px;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 23px;
  overflow: hidden;
  display: block;
  width: 24px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
}

.search input {
  border: 0;
  width: fit-content;
  height: 13px;
  cursor: initial;
  padding-top: 11px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
}

.attachment {
  overflow: scroll;
  margin-right: 0;
  display: block;
  width: 300px;
  top: -217px;
  position: relative;
  height: 147px;
  margin-left: 0;
  float: right;
  text-align: right;
  cursor: auto;
}

.attachment .item {
  height: 135px;
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: relative;
  top: -100%;
  z-index: 3;
}

.loading.transparent {
  background-color: #9191912e;
}

.progress-icon-wrapper {
  top: 0;
  bottom: 67px;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}

.progress-icon {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 28px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.toggle-list-wrapper.data-fields .item .label {
  line-height: 41px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::v-deep .quillWrapper {
  height: 100%;
}

::v-deep .ql-editor {
  height: 100%;
  margin-top: 15px;
}

::v-deep .ql-editor::before {
  font-weight: 700;
  line-height: 1.2;
  font-size: 40px;
  font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Helvetica, 'Apple Color Emoji', Arial, sans-serif, 'Segoe UI Emoji',
    'Segoe UI Symbol';
  color: rgba(0, 0, 0, 0.1);
  font-style: normal;
}

::v-deep .is-empty .ql-editor {
  font-size: 30px;
}

.content-area {
  height: 100%;
  margin: 0;
}
.content-area .row {
  height: 100%;
}

.html-editor {
  overflow: scroll;
  height: 100%;
  padding: 0;
}

.html-viewer {
  overflow: scroll;
  height: 100%;
  margin-top: 20px;
  padding: 0;
}

.html-content {
  margin-top: 8%;
}

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';

@import 'https://fonts.googleapis.com/css?family=Roboto';
@import 'https://fonts.googleapis.com/css?family=Inconsolata';
@import 'https://fonts.googleapis.com/css?family=Mirza';
/*
@import "https://fonts.googleapis.com/css?family=Arial";
/*

/*!
    * Quill Editor v1.3.7
    * https://quilljs.com/
    * Copyright (c) 2014, Jason Chen
    * Copyright (c) 2013, salesforce.com
    */

.ql-editor {
  white-space: normal !important;
}
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: '\2022';
}
.ql-editor ul[data-checked='true'],
.ql-editor ul[data-checked='false'] {
  pointer-events: none;
}
.ql-editor ul[data-checked='true'] > li *,
.ql-editor ul[data-checked='false'] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked='true'] > li::before,
.ql-editor ul[data-checked='false'] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked='true'] > li::before {
  content: '\2611';
}
.ql-editor ul[data-checked='false'] > li::before {
  content: '\2610';
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) '. ';
}
.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) '. ';
}
.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
  background-color: #000;
}
.ql-editor .ql-bg-red {
  background-color: #e60000;
}
.ql-editor .ql-bg-orange {
  background-color: #f90;
}
.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
.ql-editor .ql-bg-green {
  background-color: #008a00;
}
.ql-editor .ql-bg-blue {
  background-color: #06c;
}
.ql-editor .ql-bg-purple {
  background-color: #93f;
}
.ql-editor .ql-color-white {
  color: #fff;
}
.ql-editor .ql-color-red {
  color: #e60000;
}
.ql-editor .ql-color-orange {
  color: #f90;
}
.ql-editor .ql-color-yellow {
  color: #ff0;
}
.ql-editor .ql-color-green {
  color: #008a00;
}
.ql-editor .ql-color-blue {
  color: #06c;
}
.ql-editor .ql-color-purple {
  color: #93f;
}
.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
  font-size: 0.75em;
}
.ql-editor .ql-size-large {
  font-size: 1.5em;
}
.ql-editor .ql-size-huge {
  font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-editor .ql-align-center {
  text-align: center;
}
.ql-editor .ql-align-justify {
  text-align: justify;
}
.ql-editor .ql-align-right {
  text-align: right;
}
.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}
.ql-snow.ql-toolbar button:active:hover,
.ql-snow .ql-toolbar button:active:hover {
  outline: none;
}
.ql-snow.ql-toolbar input.ql-image[type='file'],
.ql-snow .ql-toolbar input.ql-image[type='file'] {
  display: none;
}
.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #06c;
}
@media (pointer: coarse) {
  .ql-snow.ql-toolbar button:hover:not(.ql-active),
  .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444;
  }
}
.ql-snow {
  box-sizing: border-box;
}
.ql-snow * {
  box-sizing: border-box;
}
.ql-snow .ql-hidden {
  display: none;
}
.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
  visibility: hidden;
}
.ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
.ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
.ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
.ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
.ql-snow .ql-formats:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #444;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #444;
}
.ql-snow .ql-empty {
  fill: none;
}
.ql-snow .ql-even {
  fill-rule: evenodd;
}
.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}
.ql-snow .ql-transparent {
  opacity: 0.4;
}
.ql-snow .ql-direction svg:last-child {
  display: none;
}
.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}
.ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}
.ql-snow .ql-editor h1 {
  font-size: 2em;
}
.ql-snow .ql-editor h2 {
  font-size: 1.5em;
}
.ql-snow .ql-editor h3 {
  font-size: 1.17em;
}
.ql-snow .ql-editor h4 {
  font-size: 1em;
}
.ql-snow .ql-editor h5 {
  font-size: 0.83em;
}
.ql-snow .ql-editor h6 {
  font-size: 0.67em;
}
.ql-snow .ql-editor a {
  text-decoration: underline;
}
.ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
.ql-snow .ql-editor code,
.ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
.ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
.ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
.ql-snow .ql-editor img {
  max-width: 100%;
}
.ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
.ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}
.ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
  width: 28px;
}
.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}
.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
.ql-snow
  .ql-picker.ql-header
  .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow
  .ql-picker.ql-font
  .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow
  .ql-picker.ql-size
  .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow
  .ql-picker.ql-header
  .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow
  .ql-picker.ql-font
  .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow
  .ql-picker.ql-size
  .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label);
}
.ql-snow .ql-picker.ql-header {
  width: 98px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: 'Heading 1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: 'Heading 2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: 'Heading 3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: 'Heading 4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: 'Heading 5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: 'Heading 6';
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  font-size: 2em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  font-size: 1.5em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  font-size: 1.17em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  font-size: 1em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  font-size: 0.83em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  font-size: 0.67em;
}
.ql-snow .ql-picker.ql-font {
  width: 108px;
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: 'Sans Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: 'Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: 'Monospace';
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  font-family: Georgia, Times New Roman, serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  font-family: Monaco, Courier New, monospace;
}
.ql-snow .ql-picker.ql-size {
  width: 98px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  content: 'Small';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  content: 'Large';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  content: 'Huge';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  font-size: 10px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  font-size: 32px;
}
.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}

vue-editor:focus .ql-toolbar.ql-snow {
  visibility: hidden;
}

::v-deep .ql-toolbar.ql-snow {
  pointer-events: all;
  width: fit-content;
  flex-direction: row;
  flex-shrink: 0;
  box-shadow: var(--elevation-medium);
  background: #fff;
  z-index: 100;
  margin-left: auto;
  margin-right: auto;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Inv Maison Neue, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  margin-top: -24px;
  z-index: 3;
  margin-bottom: 0px;
  position: fixed;
  left: 0;
  right: 0;
  border-radius: 6px;
  margin-top: -25px;
  height: 55px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

::v-deep .ql-toolbar.ql-snow .ql-formats {
  border: none;
  width: 132px;
  text-align: center;
  position: relative;
  padding-left: 8px;
  height: 40px;
  padding-top: 7px;
}

.ql-formats {
  position: relative;
}
.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}
.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
}
.ql-snow .ql-tooltip::before {
  content: 'Visit URL:';
  line-height: 26px;
  margin-right: 8px;
}
.ql-snow .ql-tooltip input[type='text'] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}
.ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
.ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: 'Edit';
  margin-left: 16px;
  padding-right: 8px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: 'Remove';
  margin-left: 8px;
}
.ql-snow .ql-tooltip a {
  line-height: 26px;
}
.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}
.ql-snow .ql-tooltip.ql-editing input[type='text'] {
  display: inline-block;
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: 'Save';
  padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode='link']::before {
  content: 'Enter link:';
}
.ql-snow .ql-tooltip[data-mode='formula']::before {
  content: 'Enter formula:';
}
.ql-snow .ql-tooltip[data-mode='video']::before {
  content: 'Enter video:';
}
.ql-snow a {
  color: #06c;
}

.ql-editor {
  height: 307px;
  overflow: scroll;
  padding-top: 18px;
}

.ql-toolbar.hidden {
  opacity: 0;
}

.ql-toolbar.visible {
  opacity: 1;
}

.ql-toolbar:focus-within.hidden {
  opacity: 1;
}

.ql-toolbar {
  opacity: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s ease-out;
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
}

/*
custom font size captions in toolbar
*/

.ql-picker-item[data-value='10px']::before,
.ql-picker-label[data-value='10px']::before {
  content: '10' !important;
}

.ql-picker-item[data-value='12px']::before,
.ql-picker-label[data-value='12px']::before {
  content: '12' !important;
}

.ql-picker-item[data-value='14px']::before,
.ql-picker-label[data-value='14px']::before {
  content: '14' !important;
}

.ql-picker-item[data-value='16px']::before,
.ql-picker-label[data-value='16px']::before {
  content: '16' !important;
}

.ql-picker-item[data-value='18px']::before,
.ql-picker-label[data-value='18px']::before {
  content: '18' !important;
}

.ql-picker-item[data-value='20px']::before,
.ql-picker-label[data-value='20px']::before {
  content: '20' !important;
}

.ql-picker-item[data-value='24px']::before,
.ql-picker-label[data-value='24px']::before {
  content: '24' !important;
}

.ql-picker-item[data-value='30px']::before,
.ql-picker-label[data-value='30px']::before {
  content: '30' !important;
}

.ql-picker-item[data-value='32px']::before,
.ql-picker-label[data-value='32px']::before {
  content: '32' !important;
}

.ql-picker-item[data-value='36px']::before,
.ql-picker-label[data-value='36px']::before {
  content: '36' !important;
}

/*
custom font family captions in toolbar
'arial', 'sofia', 'slabo', 'roboto', 'inconsolata', 'ubuntu'
*/

/* Set dropdown font-families */

.ql-picker-item[data-value='inconsolata']::before,
.ql-picker-label[data-value='inconsolata']::before {
  content: 'Inconsolata' !important;
}

.ql-picker-item[data-value='roboto']::before,
.ql-picker-label[data-value='roboto']::before {
  content: 'Roboto' !important;
}

.ql-picker-item[data-value='mirza']::before,
.ql-picker-label[data-value='mirza']::before {
  content: 'Mirza' !important;
}

.ql-picker-item[data-value='arial']::before,
.ql-picker-label[data-value='arial']::before {
  content: 'Arial' !important;
}

.ql-font-roboto {
  font-family: 'Roboto';
}

.ql-font-inconsolata {
  font-family: 'inconsolata';
}

.ql-font-mirza {
  font-family: 'mirza';
}

.ql-font-arial {
  font-family: 'Arial';
}

.quillWrapper {
  height: 100%;
}

.ql-editor {
  height: 100%;
}

.vue-editor.attention {
  background: rgb(245 138 138 / 24%);
}

.msg {
  position: absolute;
  top: 35%;
  left: 20%;
  background: rgb(255, 51, 102);
  border: 1px solid;
  padding: 25px;
  z-index: 5;
  border-radius: 9px;
  width: 51%;
  text-align: center;
}

.msg p {
  font-weight: 700;
  font-size: 16px;
}

::v-deep .editor {
  height: 85%;
}

::v-deep .modal.task {
  max-width: 1147px;
  width: 93%;
}

::v-deep .modal.task .tools .element .button {
  box-shadow: 0 0 0 1px #ffffff42, 0 1px 8px #ffffff52;
  z-index: 3;
}

::v-deep .modal.task .tools .element .button:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 10px 20px rgba(0, 0, 0, 0.15);
}

::v-deep .editor-content-edit-input textarea {
  z-index: 0;
}

/*+
There is no parameter to hide this option so we use css to do it 
**/
::v-deep .iconfont.icon-quanping {
  visibility: collapse;
  width: 0;
}

.modal.task .element {
  margin-right: -49px;
}

.filename-wrapper {
  position: absolute;
  content: '.pdf';
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #464d5d;
  width: 50%;
}

.filename-wrapper:after {
  position: absolute;
  right: 12px;
  top: 21px;
  /*content: ".pdf";*/
}

.props-input {
  margin-top: 20px;
  margin-left: 5px;
  font-size: 21px;
  font-weight: 500;
  border: none;
  cursor: text;
  width: 95%;
}

.is-duplicate {
  background: #ff050578;
}

.error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}

.modal-tools {
  height: 63px;
}

.modal-tools .export-wrapper {
  position: absolute;
  left: 31%;
  top: 3%;
}

.modal-tools .export-wrapper i {
  font-size: 20px;
  cursor: pointer;
}

.modal-tools .export-wrapper .export-options {
  background: white;
  height: fit-content;
  width: fit-content;
  visibility: hidden;
}

.modal-tools .export-wrapper .export-options i {
  padding: 20px;
}

.modal-tools .export-wrapper:hover .export-options {
  visibility: visible;
}

@keyframes shake {
  0% {
    margin-left: 2rem;
  }
  25% {
    margin-left: 2.2rem;
  }
  75% {
    margin-left: 1.8rem;
  }
  100% {
    margin-left: 2rem;
  }
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 4000px;
  }
}

.modal.task {
  width: 100%;
}

.modal.task .header .tools {
  position: unset;
  flex-direction: row;
  height: 60px;
  width: fit-content;
}

.modal.task .tools {
  position: unset;
  float: right;
  height: 60px;
  width: auto;
  flex-direction: row;
  margin-top: 44px;
}

.modal.task .tools .item {
  display: inline-block;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}

.round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: white;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}

/* disable tools access */

.modal >>> .disabled-tools .editor-toolbar-tools li .iconfont,
.modal >>> .disabled-tools .editor-toolbar-tools .tooltip-wrapper [title='H1'],
.modal >>> .disabled-tools .editor-toolbar-mode li .icon-tianxie,
.modal >>> .disabled-tools .editor-toolbar-mode li .icon-fenlan {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
</style>
